<template>
  <div class="api-page">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="title">API 服务</h1>
        <p class="subtitle">稳定、快速、可靠的接口服务</p>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="container">
      <!-- API服务列表 -->
      <div class="service-grid">
        <el-card v-for="service in apiServices"
                 :key="service.id"
                 class="service-card"
                 :body-style="{ padding: '0' }">
          <div class="service-header" :style="{ backgroundColor: service.color }">
            <i :class="service.icon"></i>
            <h3>{{ service.name }}</h3>
          </div>
          <div class="service-content">
            <p class="description">{{ service.description }}</p>
            <div class="service-features">
              <el-tag v-for="feature in service.features"
                      :key="feature"
                      size="small"
                      class="feature-tag">
                {{ feature }}
              </el-tag>
            </div>
            <div class="service-footer">
              <span class="price">{{ service.price }}</span>
              <el-button type="primary" size="small" @click="showDetails(service)">
                查看详情
              </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- API详情对话框 -->
    <el-dialog
        v-model="dialogVisible"
        title="接口详情"
        width="50%"
        destroy-on-close
        :close-on-click-modal="false"
        @closed="handleDialogClosed"
    >
      <AboutView :service="currentService" :params="currentParams" /> <!-- 使用 AboutView 组件 -->
    </el-dialog>
  </div>
</template>

<script>
import {ref} from 'vue'
import AboutView from '@/views/AboutView.vue'
export default {
  name: 'ApiService',
  components: {
    AboutView // 注册 AboutView 组件
  },
  setup() {
    const dialogVisible = ref(false)
    const currentService = ref(null)
    const currentParams = ref({})
    const apiServices = ref([
      // {
      //   id: 1,
      //   name: '短视频解析',
      //   description: '支持抖音、快手、小红书等平台的无水印视频解析',
      //   icon: 'el-icon-video-camera',
      //   color: '#FF6B6B',
      //   price: '免费',
      //   features: ['无水印', '高速解析', '稳定可靠'],
      //   endpoint: 'https://api.example.com/video/parse',
      //   params: [
      //     { name: 'url', type: 'string', required: '是', description: '视频链接' }
      //   ],
      //   responseExample: JSON.stringify({
      //     code: 200,
      //     msg: 'success',
      //     data: {
      //       title: '视频标题',
      //       cover: 'https://...',
      //       url: 'https://...'
      //     }
      //   }, null, 2)
      // },
      {
        id: 1,
        name: '随机怼人',
        description: '提供随机怼人的语录，适合各种场合',
        icon: 'el-icon-chat-dot-square',
        color: '#ffffff', // 红色调
        price: '免费',
        features: ['多种风格', '实时更新', '幽默搞笑'],
        endpoint: 'https://api.yuruistar.com/api/offend',
        params: [],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: 'https://test-loan-mexico-thsx.oss-cn-beijing.aliyuncs.com/uploadfile/test/1735470502466.mp4?Expires=1735474104&OSSAccessKeyId=LTAI5t5ffAeVGoA4UJTkZSbq&Signature=s4ABaqrPBRiqlvBp6S3uRHtEbZM%3D'
        }, null, 2)
      },
      {
        id: 2,
        name: '御姐撒娇',
        description: '提供各种御姐撒娇的语录，适合调侃和娱乐',
        icon: 'el-icon-sunny',
        color: '#ffffff', // 粉色调
        price: '免费',
        features: ['多种风格', '实时更新', '可爱搞笑'],
        endpoint: 'https://api.yuruistar.com/api/ImperialSister',
        params: [],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: 'https://test-loan-mexico-thsx.oss-cn-beijing.aliyuncs.com/uploadfile/test/1735470643646.mp4?Expires=1735474245&OSSAccessKeyId=LTAI5t5ffAeVGoA4UJTkZSbq&Signature=HW7SakrFFmvsyfYXvGZ7goKYcdU%3D'
        }, null, 2)
      },
      {
        id: 3,
        name: '绿茶语录',
        description: '提供各种绿茶的经典语录，适合调侃和娱乐',
        icon: 'el-icon-tea',
        color: '#ffffff', // 绿色调
        price: '免费',
        features: ['多种风格', '实时更新', '幽默搞笑'],
        endpoint: 'https://api.yuruistar.com/api/AngelicSister',
        params: [],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: 'https://test-loan-mexico-thsx.oss-cn-beijing.aliyuncs.com/uploadfile/test/1735470830106.mp4?Expires=1735474431&OSSAccessKeyId=LTAI5t5ffAeVGoA4UJTkZSbq&Signature=vrzIfX3Mla2sPiDMNwkP%2FFgRpDg%3D'
        }, null, 2)
      },
      {
        id: 4,
        name: '渣男语录',
        description: '随机生成各种风格的渣男语录，包括土味情话、高级情话等多种类型',
        icon: 'el-icon-chat-line-square',
        color: '#ffffff', // 紫色调
        //price: '￥0.001/次',
        price: '免费',
        features: ['多种类型', '实时更新', '高质量语录'],
        endpoint: 'https://api.yuruistar.com/api/scumbag',
        params: [
          // {
          //   name: 'type',
          //   type: 'string',
          //   required: '否',
          //   description: '语录类型（情话/分手/复合），默认随机'
          // },
          // {
          //   name: 'length',
          //   type: 'number',
          //   required: '否',
          //   description: '返回语录条数，默认1条'
          // }
        ],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: '我的眼里只有你，因为我的眼里进沙子了'
        }, null, 2)
      },
      {
        id: 8,
        name: '搞笑段子',
        description: '提供各种搞笑段子，适合放松心情',
        icon: 'el-icon-laughing',
        color: '#ffffff', // 金色调
        price: '免费',
        features: ['多种风格', '实时更新', '轻松幽默'],
        endpoint: 'https://api.yuruistar.com/api/funny',
        params: [
        ],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: '并多多是个好东西。没有拼多多之前50块只够我吃两顿。有了并多多后50可以花一个月！穿的是vike 吃的是康帅傅 喝的是脉劫，手机用vivi，可乐喝白事可乐。奶糖吃大白免奶糖，洗衣服用蓝月壳洗衣液，瓜子吃治治香瓜子，功能饮料喝红午，牛奶喝大个核桃加营养抉线，饼干吃粤利粤。美滋滋。刚起床我就喝着特伦特牛奶，吃着粤利粤饼干，不小心牛奶洒到了衣服上，我拿起周住牌肥皂和蓝月壳洗衣液洗了起来。要想生活好就得相信大牌子！'
        }, null, 2)
      },
      {
        id: 9,
        name: '支付宝语音',
        description: '提供支付宝语音助手服务，支持自定义余额到账搞笑语音',
        icon: 'el-icon-mic',
        color: '#ffffff', // 天蓝色调
        price: '免费',
        features: ['语音识别', '实时反馈', '便捷查询'],
        endpoint: 'https://api.yuruistar.com/api/zhifubao',
        params: [
          {
            name: 'amount',
            type: 'Float',
            required: '是',
            description: '金额'
          }
        ],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: 'https://test-loan-mexico-thsx.oss-cn-beijing.aliyuncs.com/uploadfile/test/1735471210339.mp4?Expires=1735474811&OSSAccessKeyId=LTAI5t5ffAeVGoA4UJTkZSbq&Signature=Syt4N2CHPdQe1AWz4nxD8TwyVlQ%3D'
        }, null, 2)
      },
      {
        id: 10,
        name: '肯德基疯狂星期四',
        description: '提供肯德基疯狂星期四的优惠文案，适合分享和宣传',
        icon: 'el-icon-food', // 假设使用一个食物相关的图标
        color: '#ffffff', // 橙色调
        price: '免费',
        features: ['实时更新', '多种文案风格', '适合分享'],
        endpoint: 'https://api.yuruistar.com/api/kfc',
        params: [],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: '如果上班困了喝咖啡不管用，吃根辣条就精神了；如果吃辣条没用，就去厕所自己打一套王八拳，打完就精神了；如果以上两种方法都没有用，就给我转账29.9，让我吃个疯狂星期四的肯德基蛋挞，损失29.9应该能让你彻底精神。'
        }, null, 2)
      },
      {
        id: 11,
        name: '每日沙雕新闻',
        description: '提供每日更新的沙雕新闻，适合放松心情',
        icon: 'el-icon-news', // 假设使用一个新闻相关的图标
        color: '#ffffff', // 粉红色调
        price: '免费',
        features: ['每日更新', '轻松幽默', '适合分享'],
        endpoint: 'https://api.yuruistar.com/api/sillyNews',
        params: [],
        responseExample: JSON.stringify({
          code: 200,
          msg: 'success',
          data: {
            "title": "男子因无聊在网络上悬赏通缉自己",
            "content": "只因百无聊赖，男子居然在网络上悬赏通缉自己，简直震碎三观，这不就是传说中的“no zuo no die”吗？ 11月12日上午11时，山西省长治市沁源县公安局网安大队民警在网络巡查中发现，网民“好运随时有”在某社交平台发布了一则图文，内容是： “通缉令：王一博，山西省长治市沁源县人，在2024年11月10日敲诈某公司三千万，身带冲锋枪500发子弹，发现本人奖励三万元。” 随后，民警立即展开调查工作，根据相关线索于当日中午将沁源籍男子王某某抓获，并对其住处进行了仔细搜查，结果未发现枪支、弹药等违禁物品。 经查，11月11日晚11时许，王某某由于心情苦闷，自感生活无聊，便用手机编辑了一条附带自己生活照的所谓“通缉令”，并配文后在某社交平台发布。 截至被抓获时，这条视频浏览量达35万次、点赞量2459、收藏量799、评论80条、转发1155次，造成了恶劣的社会影响。 目前，犯罪嫌疑人王某某因涉嫌编造、故意传播虚假信息罪已被依法采取刑事强制措施。 警察蜀黍有话说：网络不是法外之地，造谣传谣属违法犯罪行为，别为了逞一时之快，编造、传播虚假信息，到头来把自己搭进去！ 新浪微博:  "
          }
        }, null, 2)
      }
    ])

    const showDetails = (service) => {
      currentService.value = service
      currentParams.value = {
        // 根据服务的内容动态设置请求参数
        endpoint: service.endpoint,
        // 你可以根据需要添加其他参数
        // 例如，如果服务有特定的参数，可以在这里设置
        // type: service.type || 'default',
        // length: service.length || 1
      }
      dialogVisible.value = true
    }

    const handleDialogClosed = () => {
      currentService.value = null
      currentParams.value = {}
    }

    return {
      dialogVisible,
      currentService,
      currentParams,
      showDetails,
      handleDialogClosed,
      apiServices
    }
  }
}
</script>

<style scoped>
.api-page {
  min-height: 100vh;
}

.banner {
  height: 300px; /* 增加高度 */
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center;
  margin-top: -60px;
}

.banner-content {
  text-align: center;
  color: white;
  padding-top: 60px; /* 添加顶部内边距，抵消导航栏的高度 */
}

.title {
  font-size: 48px;
  margin: 10px 0; /* 调整上下间距 */
  padding-top: 30px;
  font-weight: 600; /* 加粗标题 */
}
.subtitle {
  font-size: 24px;
  opacity: 0.9; /* 稍微降低透明度 */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.service-grid {
  display: grid;
  //grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 20px;
}

.service-card {
  transition: transform 0.3s;
}

.service-card:hover {
  transform: translateY(-4px);
}

.service-header {
  padding: 20px;
  color: #000000;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.service-header i {
  font-size: 32px;
  margin-bottom: 12px;
}

.service-header h3 {
  margin: 0;
  font-size: 20px;
}

.service-content {
  padding: 20px;
}

.description {
  color: #666;
  margin-bottom: 16px;
  min-height: 44px;
}

.service-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.feature-tag {
  font-size: 12px;
}

.service-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.price {
  font-size: 18px;
  color: #ff4d4f;
  font-weight: bold;
}

.api-details h4 {
  margin: 20px 0 10px;
  color: #333;
}

.response-example {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
}

@media (max-width: 768px) {
  .title {
    font-size: 32px;
  }

  .subtitle {
    font-size: 18px;
  }

  .service-grid {
    grid-template-columns: 1fr;
  }
}


.api-details {
  padding: 20px 0;
}

.params-table {
  margin: 20px 0;
}

.params-table h4,
.response-section h4 {
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
}

.response-section {
  margin-top: 20px;
}

.response-example {
  background: #f6f8fa;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.5;
  border: 1px solid #eee;
}

:deep(.el-descriptions__label) {
  width: 120px;
  font-weight: bold;
}

:deep(.el-dialog__body) {
  padding: 20px;
}
</style>
